import React from 'react';
import {getEnvironment} from '../../app/App';
import MapContainer from '../Map/MapContainer';
import { ToastContainer} from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'react-toastify/dist/ReactToastify.css';

class List extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      directories: [],
      actions: [],
      companies: [],
      nameCompany: '',
      phoneNumber: '',
      nameOwner: '',
      municipio: '',
      direction: '',
      schedule: '',
      showMessageWarning: false,
      showMessageError: false,
      isActive: true
    }
      this.onSavePreCustomer = this.onSavePreCustomer.bind(this);
      this.onChangeNameCompany = this.onChangeNameCompany.bind(this);
      this.onChangePhone = this.onChangePhone.bind(this);
      this.onChangeNameOwner = this.onChangeNameOwner.bind(this);
      this.onChangeMunicipio = this.onChangeMunicipio.bind(this);
      this.onChangeLocation = this.onChangeLocation.bind(this);
      this.onChangeHorario = this.onChangeHorario.bind(this);
  }





  hideMessage(){
    this.setState({showMessageWarning: false, showMessageError: false});
  }

  onConfirmUnBloc() {
    this.hideMessageWarnings();
  }

  onConfirmError(){
  this.hideMessage();
}

  onCancelBlock(){
    this.hideMessage();
  }

  hideMessageWarnings() {
  this.setState({
    showMessageWarning: false
  });
}

  clean() {
    document.getElementById("preCustomerForm").reset();
  }

  onChangeNameCompany(event){
    this.setState({ nameCompany:  event.target.value});
  }

  onChangePhone(event){
    this.setState({ phoneNumber:  event.target.value});
  }

  onChangeNameOwner(event){
    this.setState({ nameOwner:  event.target.value});
  }

  onChangeMunicipio(event){
    this.setState({ municipio:  event.target.value});
  }

  onChangeLocation(event){
    this.setState({ direction:  event.target.value});
  }

  onChangeHorario(event){
    this.setState({ schedule:  event.target.value});
  }

  componentDidMount() {
    this.getCompany();
  }

  onSavePreCustomer() {
    let confCurrent = getEnvironment();
    let isValid = true;

    if (this.state.nameCompany === '' || this.state.phoneNumber === '' || this.state.nameOwner === '' || this.state.municipio === '' ||
            this.state.direction === '' || this.state.schedule === '') {
         isValid = false;
    }

    if (isValid) {
      const axios = require('axios');
      var datos = new FormData();
      datos.append("name_company", this.state.nameCompany);
      datos.append("phone_number", this.state.phoneNumber);
      datos.append("name_owner", this.state.nameOwner);
      datos.append("municipio", this.state.municipio);
      datos.append("direction", this.state.direction);
      datos.append("schedule", this.state.schedule);
      let that = this;
      axios.post(confCurrent.home +'a/save/pre/customer/' + Date.now(), datos)
      .then(function (response) {
        console.log(response);
        if(response.data.success === 'true' || response.data.success === true){
          console.log('preCustomer agregado');
          that.clean();
          that.setState({
            showMessageWarning: true,
            showMessageError: false
          });
        } else {
          console.log('user no  agregado');
          that.setState({
            showMessageWarning: false,
            showMessageError: true
          });
        }
      }).catch(function (error) {
        console.log('ha ocurrido un error');
        that.setState({showMessageWarning: false,showMessageError: true});
      });
    } else {
      console.log('llena todos los campos');
      this.setState({showMessageWarning: false,showMessageError: true});
    }
  }


  getCompany(){
    console.log('consultando lista');
    const axios = require('axios');
    var datos = new FormData();
    let that = this;
    var confCurrent = getEnvironment(this.state.idDirectory);
    axios.post(confCurrent.home +'a/list/get/' + Date.now(), datos)
    .then(function (response) {
      console.log(response);
      if(response.data.data.Directories != null && response.data.data.Directories !== ''){
        that.setState({directories: response.data.data.Directories, loading: false});
      }else{
        that.setState({directories: [], loading: false});
      }

    })
    .catch(function (error) {
      console.log(error);
    });
  }


  getDirectoriesName(){
      const companyName = [];
      for(var x=0;x < this.state.directories.length;x++){
          const directory = this.state.directories[x];
            companyName.push(
              <div className="container hide-directoris">
                <div className="row pd-row">
                  <div className="col-lg-1 dis-div"></div>
                    <div className="nav-item active">
                      <a className="nav-link" href={"https://rapidiux.com/" + directory.token}>{directory.name}</a>
                    </div>
                </div>
              </div>
            );

       }

    return companyName;
    }

render (){
  var confCurrent = getEnvironment(this.state.idDirectory);
  const s = {width: '30px' , height: '30px'};

  return (
    <React.Fragment>
     <nav className="navbar navbar-expand-lg navbar-light border-list nav-hide-desk">
        <a href="https://rapidiux.com">
            <img className="pd-nav logo-rap"  href="https://rapidiux.com" src={confCurrent.home + "assets/images/directory/header_logo.png"} alt="logo rapidiux"/>
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="pd-social">
                <a href="https://rapidiux.com/facebook" target="_self">
                  <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png"}  className="mx-auto"  alt="" style={s}/>
                </a>
            </li><a href="https://rapidiux.com/facebook" className="tx-redirect">/rapidiux</a>
            <li className=" pd-social">
                <a href="https://rapidiux.com/7341589302" target="_self">
                  <span><img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className="mx-auto"  alt="" style={s}/>  </span>
                </a>
            </li><a href="https://rapidiux.com/7341589302" className="tx-redirect">734 158 9302</a>
          </ul>
          <ul className="">
            <button type="button" className="btn btn-primary txt-btn btn-add" data-toggle="modal" data-target="#login">Inscribe tu negocio</button>
          </ul>
        </div>
      </nav>

      <nav className="navbar navbar-expand-lg navbar-light nav-hide-phone">
        <a href="https://rapidiux.com">
            <img className="pd-nav logo-rap" src={confCurrent.home + "assets/images/directory/header_logo.png"} alt="rapidiux"/>
        </a>
         <button className="navbar-toggler btn-hide" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
           <span className="navbar-toggler-icon"></span>
         </button>
         <div className="collapse navbar-collapse" id="navbarNav">
           <ul className="navbar-nav nav-pd">
             {this.state.directories.map(function(directory) {
                 return (
             <li className="nav-item active company-menu">
                <a className="nav-link" href={"https://rapidiux.com/" + directory.token}>{directory.name}</a>
             </li>
             )
             })}
           </ul>
         </div>
       </nav>


       <div className="hide-directoris">
          <div className="row pd-row">
              {this.state.directories.map(function(directory) {
                  return (
                    <div className="nav-item active">
                      <a className="nav-link" href={"https://rapidiux.com/" + directory.token}>{directory.name}</a>
                    </div>
                  )
              })}
          </div>
        </div>

      <div className="container ctn-responsive">
        <div className="row">
          <div className="col-md-4 col-sm-4 cl-aling">
            <a href="https://rapidiux.com/facebook" target="_self">
                <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png"}  className="mx-auto d-block img-social"  alt=""/><p className="txt-social"> /rapidiux</p>
            </a>
          </div>
          <div className="col-md-4 col-sm-4 cl-aling">
            <a href="https://rapidiux.com/7341589302" target="_self">
                <img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className="mx-auto d-block img-social"  alt=""/><p className="txt-social">734 158 9302</p>
            </a>
          </div>
          <div className="col-md-4 col-sm-4">
          <button type="button" className="btn btn-primary txt-btn btn-add" data-toggle="modal" data-target="#login">Inscribe tu negocio</button>
          </div>
        </div>
      </div>

      <input type="checkbox" id="cerrar" className="cerrar" />
        <div className="modal fade"  tabIndex="-1" role="dialog" aria-labelledby="registermodal">
            <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
             <div className="modal-content mdal-wd">
             <label for="cerrar" id="btn-cerrar" className="close-x">X</label>
                <img className="lg-card" src={confCurrent.home + "assets/images/directory/logo_modal.png"} alt="logo rapidiux"/>
                <div className="modal-body">
                  <h4 className="modal-header-title text-center txt-welcome">! Bienvenido a  <span className="theme-cl">Rapidiux !</span></h4>
                  <div className="row">
                      <div className="">
                        <p className="txt-body">Hola a todos, somos <span className="text-w"> Rapidiux </span>tu mejor aliado para tus entregas a domicilio.  </p>
                        <p className="txt-body">Si tienes un negocio inscríbite a nuestro directorio comercial <br></br><span className="text-w">¡es gratis!</span>  </p>

                        <p className="txt-card-default">Activa tu ubicación y conoce los negocios que están más cerca de ti.</p>

                      </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

      <MapContainer props={this.state}/>


      <footer className="dark-footer skin-dark-footer  fter-down">
          <div className="footer-bottom">
              <div className="container">
                  <div className="row align-items-center">
                      <div className="col-lg-12 col-md-12 text-center">
                        <p className="mb-0 txt-footer">© 2020 Rapidiux. Design By <a className="txt-sof" href="https://softiux.com">SoftiUX</a> All Rights Reserved</p>
                      </div>
                  </div>
              </div>
          </div>
      </footer>

      <div className="modal2 fade" id="login" tabIndex="-1" role="dialog" aria-labelledby="registermodal">
        <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
          <div className="modal-content" id="registermodal" >
            <span className="mod-close" data-dismiss="modal">X</span>
            <img className="lg-card" src={confCurrent.home + "assets/images/directory/logo_modal.png"} alt="logo rapidiux"/>
            <div className="modal-body">
              <h4 className="modal-header-title text-center">! Inscribete <span className="theme-cl">es gratis !</span></h4>
                <div className="login-form">
                  <form id="preCustomerForm">
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Nombre del negocio</p>
                      <div className="input-with-icon">
                        <input type="text" onChange={this.onChangeNameCompany} className="form-control" name="name_company" id="nameCompany"/>
                       </div>
                    </div>
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Teléfono(s) y WhatsApp</p>
                      <div className="input-with-icon">
                          <input type="text" onChange={this.onChangePhone} className="form-control" name="phone_number" id="phoneNumber"/>
                      </div>
                    </div>
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Nombre del propietario</p>
                      <div className="input-with-icon">
                          <input type="text" onChange={this.onChangeNameOwner} className="form-control" name="name_owner" id="nameOwner"/>
                      </div>
                    </div>
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Municipio</p>
                      <div className="input-with-icon">
                          <input type="text" onChange={this.onChangeMunicipio} className="form-control" name="municipio" id="municipio"/>
                      </div>
                    </div>
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Dirección</p>
                      <div className="input-with-icon">
                          <input type="text" onChange={this.onChangeLocation} className="form-control" name="direction" id="direction"/>
                      </div>
                    </div>
                    <div className="fm-input">
                      <p className="float-left txt-bl  ft-input">Horario</p>
                      <div className="input-with-icon">
                          <input type="text" onChange={this.onChangeHorario} className="form-control" name="schedule" id="schedule" placeholder="Indicar días y horario"/>
                      </div>
                    </div>
                    <div className="form-group">
                      <button type="button" onClick={this.onSavePreCustomer} className="btn btn-md full-width pop-login">Enviar</button>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />

      <SweetAlert warning title="Datos enviados" onConfirm={() => this.onConfirmUnBloc()} show={this.state.showMessageWarning}>
        Sus datos han sido enviados. Uno de nuestros representantes le hara una llamada telefónica.
      </SweetAlert>

      <SweetAlert error title="Error" onConfirm={() => this.onConfirmError()} show={this.state.showMessageError}>
        Hubo un error al guardar el cliente
      </SweetAlert>

    </React.Fragment>
    )

  }

}
export default List;
